export default __webpack_public_path__ + "static/media/quiz_bg.90cd6c5c.png";